import { type ReferralMessageModel } from '../models/ReferralMessageModel';

export function filterConversationMessages(
  messages: ReferralMessageModel[],
  senderFacilityId: string,
  recipientFacilityId: string
) {
  return messages.filter((message) => {
    if (message.isSystemEvent()) {
      return true;
    }

    if (!message.receiver_facility_id) {
      return (
        message.sender_facility_id === senderFacilityId ||
        message.sender_facility_id === recipientFacilityId
      );
    }

    return (
      (message.sender_facility_id === senderFacilityId &&
        message.receiver_facility_id === recipientFacilityId) ||
      (message.sender_facility_id === recipientFacilityId &&
        message.receiver_facility_id === senderFacilityId)
    );
  });
}
